// src/services/efectorService.js
import api from "./Api"; // cliente unificado (dev/prod resuelto dentro)

// Bases por controlador
const EF = "/Efectores";
const DISP = "/Dispositivos";

// ---------- Efectores (CRUD / catálogos) ----------
export const crearEfector = async (efectorData) => {
  const { data } = await api.post(`${EF}/crear`, efectorData);
  return data;
};

export const obtenerTiposEfector = async () => {
  const { data } = await api.cachedGet(`${EF}/tipos`);
  return data;
};

// Si tu backend expone este helper:
export const obtenerDispositivosPorEstanque = async (estanqueId) => {
  const { data } = await api.cachedGet(`${DISP}/mis-dispositivos`);
  return (data || []).filter((dispositivo) => dispositivo.estanqueId === Number(estanqueId));
};

// GET /Efectores/efectores/estanque/{id}
export const obtenerEfectoresPorEstanque = async (estanqueId) => {
  const { data } = await api.cachedGet(`${EF}/mis-efectores`);
  return (data || []).filter((efector) => efector.estanqueId === Number(estanqueId));
};

export const obtenerTodosLosEfectores = async () => {
  const { data } = await api.cachedGet(`${EF}/todos`);
  return data;
};

export const actualizarEfector = async (id, efectorData) => {
  const { data } = await api.put(`${EF}/actualizar/${id}`, efectorData);
  return data;
};

// ---------- Sincronización con el ESP32 ----------
export const sincronizarEncendido = async (efectorId) => {
  const { data } = await api.post(`${DISP}/${efectorId}/sincronizar--encendido`, {});
  return data;
};

export const aplicarEstado = (efectorId) => sincronizarEncendido(efectorId);

// (Opcional) Mantener como aviso explícito
export const setEncendidoDb = async () => {
  throw new Error(
    "setEncendidoDb no está implementado en el backend actual. Usa actualizarEfector() + sincronizarEncendido()."
  );
};

// PATCH/PUT específico (si existe en tu backend)
export const setEncendido = async (id, payload) => {
  const { data } = await api.put(`${EF}/${id}/encendido`, payload);
  return data;
};

const efectorService = {
  crearEfector,
  obtenerTiposEfector,
  obtenerDispositivosPorEstanque,
  obtenerEfectoresPorEstanque,
  obtenerTodosLosEfectores,
  actualizarEfector,
  sincronizarEncendido,
  aplicarEstado,
  setEncendido,
  setEncendidoDb,
};

export default efectorService;
